import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-point-container',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  templateUrl: './point-container.component.html',
  styleUrl: './point-container.component.scss'
})
export class PointContainerComponent {

}
